import React from "react";
import UserQueryTable from "./UserQueryTable/index"
import { getUserPreference } from "../../../utilities/common";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { TextField, Button, Grid, MenuItem, makeStyles, IconButton } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { useToken, useAlert } from "../../../utilities/hooks";
import moment from 'moment';
import DateRangePicker from "../../Common/DateTimeRangePicker";
import update from 'immutability-helper';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import _ from "lodash";
import { getBranchList } from '../../../actions/commonAction'
import {
    getUserOrderExchangeInfo,
    downloadUserOrderExchangeInfo
} from "../../../actions/orderExchangeActions";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
    grid: {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'right',
        flexDirection: 'column',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2), // 调整上方间距
        marginBottom: theme.spacing(-2), // 调整下方间距
    },
    firstGrid: {
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'right',
        flexDirection: 'column',
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2), // 调整上方间距
        marginBottom: theme.spacing(-2), // 调整下方间距
    },
    dateRangeRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: theme.spacing(2)
    },
    textField: {
        width: '100%',
    },
    Button: {
        marginTop: theme.spacing(2), // 调整上方间距
        display: 'flex',
        alignItems: 'right',
        marginRight: theme.spacing(-7),
    },
    searchButton: {
        backgroundColor: 'gray',
        color: 'white',
        '&:hover': {
            backgroundColor: 'darkgray',
        },
    },
    refreshButton: {
        backgroundColor: 'gray',
        color: 'white',
        '&:hover': {
            backgroundColor: 'darkgray',
        },
    },
    icon: {
        width: '21.9px',
        height: '21.9px',
    },
}));

function UserQuery() {
    const warehouseIdsToShow = [1, 2, 4];

    const [dateRange, setDateRange] = useState({
        from: moment().startOf('day'),
        to: moment().endOf('day')
    });

    const { t } = useTranslation('orderExchange');
    const dispatch = useDispatch();
    const classes = useStyles();
    const userPref = getUserPreference();
    const [selectedItem, setSelectedItem] = useState();
    const [detailedDate, setDetailedDate] = useState([]);
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [timezone, setTimezone] = useState('');
    const tokenContents = useToken();
    const [warehouses, setWarehouses] = useState([]);
    const [selectedWarehouses, setSelectedWarehouses] = useState([]);
    const alertDialog = useAlert();

    const filteredWarehouses = warehouses.filter((warehouse) =>
        warehouseIdsToShow.includes(warehouse.id)
    );

    const handleDateChange = (event) => {
        let newValue = update(dateRange, {
            [event.target.id]: {
                $set: moment(event.target.value)
            }
        });
        setDateRange(newValue);
    };

    const handleWarehouseChange = (event, newValue) => {
        const selectedwarehouses = newValue.map((warehouse) => warehouse.id);
        setSelectedWarehouses(selectedwarehouses);
    };


    const handleSearch = () => {
        setIsDataLoading(true);

        const fromDateTimestamp = Math.floor(new Date(dateRange.from).getTime() / 1000);
        const toDateTimestamp = Math.floor(new Date(dateRange.to).getTime() / 1000);

        const params = {
            from_date: fromDateTimestamp,
            to_date: toDateTimestamp,
        };

        if (!_.isNil(selectedWarehouses) && selectedWarehouses !== "") {
            params.warehouses = selectedWarehouses;
        }

        dispatch(getUserOrderExchangeInfo(params))
            .then((response) => {
                setDetailedDate(response);
                dispatch(showAlertSnackbar({
                    title: t('bbc_order_exchange'),
                    message: t('search_success'),
                    type: 'success'
                }));
            })
            .catch((error) => {
                dispatch(showAlertSnackbar({
                    title: t('bbc_order_exchange'),
                    message: t('search_failed'),
                    type: 'error'
                }));
                setDetailedDate([]);  // Clear the table data
                setSelectedItem('');
            })
            .finally(() => {
                setIsDataLoading(false);
            });
    };

    const handleFileDownload = async () => {
        try {
            setIsDataLoading(true);
            const fromDateTimestamp = Math.floor(new Date(dateRange.from).getTime() / 1000);
            const toDateTimestamp = Math.floor(new Date(dateRange.to).getTime() / 1000);

            const params = {
                from_date: fromDateTimestamp,
                to_date: toDateTimestamp,
            };

            if (!_.isNil(selectedWarehouses) && selectedWarehouses.length > 0) {
                params.warehouses = selectedWarehouses;
            }

            const response = await dispatch(downloadUserOrderExchangeInfo(params));
        } catch (error) {
            alertDialog.addAlertDialog(t('dialog:download_failed'), error.message || error.additional);
            alertDialog.showAlert();
            console.error(error);
        } finally {
            setIsDataLoading(false);
        }
    };

    const handleSelectedItems = (items) => {
        setSelectedItem(items);
    }

    useEffect(() => {
        dispatch(getBranchList()).then((warehouses) => {
            setWarehouses(warehouses);
        });
    }, []);

    return (
        <>
            <Grid container spacing={0}>
                <Grid item xs={2.5} className={classes.firstGrid}>
                    <DateRangePicker
                        type="minutes"
                        className={classes.dateRangeRow}
                        fromDateValue={dateRange.from}
                        toDateValue={dateRange.to}
                        textFieldStyle={{
                            minWidth: 100,
                            flex: 1
                        }}
                        handleDateChange={handleDateChange}
                    />
                </Grid>
                <Grid item xs={4} className={classes.grid}>
                    <Autocomplete
                        multiple
                        options={filteredWarehouses} // 使用过滤后的仓库列表
                        getOptionLabel={(option) => option.name}
                        value={warehouses.filter((warehouse) =>
                            selectedWarehouses.includes(warehouse.id)
                        )}
                        onChange={handleWarehouseChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label={t('warehouse')}
                                className={classes.textField}
                                inputProps={{
                                    ...params.inputProps,
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={0.5} className={classes.grid}>
                    <IconButton id="hoursreivew_searchButton_iconbutton" color="primary" className={classes.searchButton} onClick={handleSearch}
                    >
                        <Search className={classes.icon} />
                    </IconButton>
                </Grid>
                <Grid item xs={0.5} className={classes.grid}>
                    <IconButton id="hoursreivew_searchButton_iconbutton" color="primary" className={classes.searchButton} onClick={handleFileDownload}
                    >
                        <CloudDownloadIcon className={classes.icon} />
                    </IconButton>
                </Grid>
                <Grid item xs={12} >
                    <UserQueryTable
                        data={detailedDate}
                        isDataLoading={isDataLoading}
                        setSelectedItems={handleSelectedItems}
                        timezone={timezone}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default UserQuery;
